import React, {Component} from 'react';

import services from './../../services';

import layouts from './../../layouts';
import Modal from './../Modal';
import Grid from './../Grid';
import Submit from './../Submit';

import Code from './../employee/Code';
import Name from './../employee/Name';

import org from './../org';


export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keywords: {
            },
            domain: {
                employeeIds: []
            }
        };

        this.domain = {};

        services.employee.onSelect([]);
    }

    componentWillReceiveProps(nextProps) {
        const roleId = nextProps.roleId;
        if(roleId) {
            this.setState({
                keywords: {
                    roleId,
                    v: Math.random(),
                    pageNum: 1,
                    orgId: '', 
                    employeeCode: '', 
                    realName: ''
                },
                domain: {
                    roleId,
                }
            })
        }
        
    }

    handleSubmit() {
        const data = Object.assign({}, this.state.domain, {employeeIds: services.employee.getSelection()});
        services.roles.removRoleEmployee(data).then(d => {
            this.handleCancel();
        });
    }

    handleChange(data) {
        //this.domain = Object.assign({}, this.domain, data);
        this.setState({
            keywords: Object.assign({}, this.state.keywords, data)
        });
    }

    handleSearchSubmit() {
        this.setState({
            keywords: Object.assign({}, this.state.keywords, this.domain, {
                v: Date.now(),
                pageNum: 1
            })
        });
    }
    
    handleCancel() {
        this.props.handleCancel();
        this.setState({
            keywords: {v: Date.now(), visible: this.props.visible, orgId: '', employeeCode: '', realName: ''},
        })
    }

    render() {
        return (
            <Modal title="查看及删除组成员" visible={this.props.visible}  handleSubmit={this.handleSubmit.bind(this)} handleCancel={this.handleCancel.bind(this)} okText = {"确定删除"}>
                <layouts.Search onSubmit={this.handleSearchSubmit.bind(this)}>
                    <div>
                        <div className="search-item">
                            <org.Name name="orgId" type={'all'} style={{width: 160}} value={this.state.keywords.orgId} handleChange={this.handleChange.bind(this)} />
                            <Code name="employeeCode" style={{width: 160}}  value={this.state.keywords.employeeCode} handleChange={this.handleChange.bind(this)} />
                            <Name name="realName" style={{width: 160}} value={this.state.keywords.realName} handleChange={this.handleChange.bind(this)} />
                            <Submit>检索</Submit>
                        </div>
                    </div>
                </layouts.Search>
                <Grid ismodal="true" keywords={this.state.keywords} service={services.employee}/>
            </Modal>
        )
    }
}